import { Spinner } from 'react-bootstrap';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'md', text = '' }) => {
  const spinnerSize = size === 'sm' ? 'sm' : undefined;

  return (
    <div className="loading-spinner">
      <Spinner animation="border" variant="primary" size={spinnerSize} role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
